import { render, staticRenderFns } from "./DynamicInboundCalls.vue?vue&type=template&id=1c8e57d7"
import script from "./DynamicInboundCalls.vue?vue&type=script&lang=js"
export * from "./DynamicInboundCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports